import { useEffect } from "react";

export default function useCursor() {
  useEffect(() => {
    const dot = document.createElement("div");
    dot.className = "cursor-dot";
    dot.setAttribute("aria-hidden", "true");
    document.body.appendChild(dot);

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x, ty = y;

    const onMove = (e) => {
      tx = e.clientX; ty = e.clientY;
    };
    window.addEventListener("mousemove", onMove);

    let raf;
    const loop = () => {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      dot.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const grow = () => { dot.style.width = "44px"; dot.style.height = "44px"; dot.style.background = "#0A0A0C"; };
    const shrink = () => { dot.style.width = "8px"; dot.style.height = "8px"; };
    document.querySelectorAll("a, button, [data-cursor='grow']").forEach((el) => {
      el.addEventListener("mouseenter", grow);
      el.addEventListener("mouseleave", shrink);
    });

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      dot.remove();
    };
  }, []);
}
